export const BASE = "/sso2/api/v1";
export const BASE_WITH_TENANT = "/sso2/{tenant}/public/v1";
export const SITI_AGRI = "/sitiagri-rest-api/api_basic/v1"
